<style scoped lang="scss">
  
  @media screen and (min-width: 768px) {
    .container-phone {
      display: none;
    }
    .category{
      padding:30px;
      background: #F9F9F9;
      li{
        margin-bottom: 20px;
        cursor: pointer;
        &.active{
          color:#014492;
        }
        &:last-child{
          margin-bottom: 0;
        }
      }
    }
    .search-result{
      .title{
        font-size: 24px;
        font-weight: bold;
      }
      li{
        margin-top: 40px;
      }
      span{
        color: #014492;
      }
      small{
        font-size: 12px;
        color: #999;
        margin-top: 10px;
        display: block;
      }
    }
  }
  @media screen and (max-width: 768px) {
    .container {
      display: none;
    }
    .category{
      padding:10px;
      background: #F9F9F9;
      li{
        margin-bottom: 15px;
        cursor: pointer;
        &.active{
          color:#014492;
        }
        &:last-child{
          margin-bottom: 0;
        }
      }
    }
    .search-result{
      padding: 0 10px;
      .title{
        font-size: 16px;
        font-weight: bold;
        margin-top: 10px;
        text-align: center;
      }
      li{
        margin-top: 10px;
      }
      span{
        color: #014492;
      }
      small{
        font-size: 12px;
        color: #999;
        margin-top: 5px;
        display: block;
      }
    }
  }
</style>
<template>
  <div class="wrap wrap-search">
    <section class="container">
      <el-row :gutter="50">
        <el-col :span="5">
          <ul class="category">
            <li :class="{active: currentTab === 0}" @click="changeTab(0)">全部（{{total}}）</li>
            <li :class="{active: currentTab === 1}" @click="changeTab(1)">分子产品（{{molecularLists.length}}）</li>
            <li :class="{active: currentTab === 2}" @click="changeTab(2)">技术服务（{{tecLists.length}}）</li>
            <li :class="{active: currentTab === 3}" @click="changeTab(3)">智能制造（{{manufacturingList.length}}）</li>
            <li :class="{active: currentTab === 4}" @click="changeTab(4)">擎科概况（{{infoList.length}}）</li>
          </ul>
        </el-col>
        <el-col :span="19">
          <div class="search-result">
            <div class="title">整站中“<span>{{keywords}}</span>”的搜索结果</div>
            <ul>
              <li v-for="item in resultLists" :key="item.id" @click="toDetails(item)">
                <p class="pointer" v-html="item.title"></p>
                <small>来自：{{item.typeName}}</small>
              </li>
            </ul>
            <div class="no-data" v-show="resultLists.length === 0">未查询到相关结果</div>
          </div>
        </el-col>
      </el-row>
    </section>
    <!-- 适配移动端 搜索 样式 -->
    <section class="container-phone">
      <el-row :gutter="50">
        <el-col :span="24">
          <ul class="category">
            <li :class="{active: currentTab === 0}" @click="changeTab(0)">全部（{{total}}）</li>
            <li :class="{active: currentTab === 1}" @click="changeTab(1)">分子产品（{{molecularLists.length}}）</li>
            <li :class="{active: currentTab === 2}" @click="changeTab(2)">技术服务（{{tecLists.length}}）</li>
            <li :class="{active: currentTab === 3}" @click="changeTab(3)">智能制造（{{manufacturingList.length}}）</li>
            <li :class="{active: currentTab === 4}" @click="changeTab(4)">擎科概况（{{infoList.length}}）</li>
          </ul>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="search-result">
            <div class="title">整站中“<span>{{keywords}}</span>”的搜索结果</div>
            <ul>
              <li v-for="item in resultLists" :key="item.id" @click="toDetails(item)">
                <p class="pointer" v-html="item.title"></p>
                <small>来自：{{item.typeName}}</small>
              </li>
            </ul>
            <div class="no-data" v-show="resultLists.length === 0">未查询到相关结果</div>
          </div>
        </el-col>
      </el-row>
    </section>
    <!-- 适配移动端 搜索 样式 -->
  </div>
</template>

<script>
import { search } from '@/services/api.index'

export default {
  data () {
    return {
      keywords: this.$route.query.keywords,
      total: 0,
      allLists: [],
      molecularLists: [],
      tecLists: [],
      manufacturingList: [],
      infoList: [],
      resultLists: [],
      currentTab: 0
    }
  },
  created() {
    this.searchResult()
  },
  methods: {
    // 查询搜索结果
    searchResult () {
      this.molecularLists = []
      this.tecLists = []
      this.manufacturingList = []
      this.infoList = []
      search(this.keywords).then(res => {
        this.allLists = res.data
        this.allLists.map(item => {
          const title = item.title
          item.title = title.replace(new RegExp(this.keywords, 'g'), `<span class="text-primary">${this.keywords}</span>`)
          switch(item.type) {
            case 'PRODUCT':
              item.typeName = '分子产品'
              this.molecularLists.push(item)
              break;
            case 'SERVICE':
              item.typeName = '技术服务'
              this.tecLists.push(item)
              break;
            case 'MANUFACTURING':
              item.typeName = '智能制造'
              this.manufacturingList.push(item)
              break;
            case 'INFO':
              item.typeName = '擎科概况'
              this.infoList.push(item)
              break;
          }
        })
        this.resultLists = this.allLists
        this.total = this.allLists.length
      })
    },
    changeTab (index) {
      this.currentTab = index
      switch (index) {
        case 0:
          this.resultLists = this.allLists
          break
        case 1:
          this.resultLists = this.molecularLists
          break
        case 2:
          this.resultLists = this.tecLists
          break
        case 3:
          this.resultLists = this.manufacturingList
          break
        case 4:
          this.resultLists = this.infoList
          break
      }
    },
    // 跳转到详情页
    toDetails (item) {
      switch(item.type) {
        case "PRODUCT":
          this.$router.push(`/products/details/${item.sourceId}`)
          break;
        default:
          this.$router.push(item.url);
      }
    }
  },
  watch: {
    $route (to, from) {
      this.keywords = to.query.keywords
      this.searchResult()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/search.vue